import { type PayloadAction, createSlice } from "@reduxjs/toolkit";

export type GradeFeaturesAssetType = {
    url: string;
    type: string;
};
export type GradeFeaturesType = {
    id: string;
    name: string;
    subtitle?: string;
    description: SanitizedString;
    learnMore?: SanitizedString;
    assets: GradeFeaturesAssetType[];
    valid: boolean; // Determines if the GradeFeature should be rendered or not
};

export type GradeType = {
    name: string;
    id: string;
    defaultCarId: string;
    gradeFeatures: GradeFeaturesType[];
};

export type GradesStateType = {
    initialized: boolean;
    items: GradeType[];
};

export const initialState: GradesStateType = {
    items: [],
    initialized: false,
};

export type CarConfigGradesActionTypes = ReturnType<typeof initCarConfigGrades>;

export const CarConfigGradesSlice = createSlice({
    name: "grades",
    initialState,
    reducers: {
        initCarConfigGrades(state, action: PayloadAction<GradesStateType>) {
            return {
                ...state,
                ...action.payload,
            };
        },
    },
});

export const { initCarConfigGrades } = CarConfigGradesSlice.actions;
